import { createContext } from 'react'

/**
 * Provides poll runtime data to puck components rendered in production mode
 * via <Render />. PollItem is the provider; puck poll components (e.g.
 * PollProductPanel, PollProduct) are consumers.
 *
 * This allows puck components to be self-sufficient in production — they
 * read poll state from context instead of receiving it through the legacy
 * prop-drilling chain.
 */
const PuckPollContext = createContext({
  poll: null,
  question: null,
  products: [],
  productsTitle: 'Shop Products',
  onAnswerLinkClick: null,
  onAnswerDropdownClick: null,
})

export default PuckPollContext
